/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_COMMON_DROPDOWN_DATA_CI = 'GET_COMMON_DROPDOWN_DATA_CI';
export const SELECTION_TYPE_OPTIONS = 'SELECTION_TYPE_OPTIONS';
export const HANDLE_ERROR_MESSAGE = 'HANDLE_ERROR_MESSAGE';
export const DROPDOWN_UPDATED_LIST = 'DROPDOWN_UPDATED_LIST';
export const RESET_INCONSISTENCIES_DATA = 'RESET_INCONSISTENCIES_DATA';
export const GET_MANUFACTURER_GRID_LIST = 'GET_MANUFACTURER_GRID_LIST';
export const GET_MAX_QUARTER = 'GET_MAX_QUARTER';
export const HEADER_INCONSISTENT_DETAILS = 'HEADER_INCONSISTENT_DETAILS';
export const FLAG_NAVIGATION = 'FLAG_NAVIGATION';
export const SINGLE_INCONSISTENT_DATA = 'SINGLE_INCONSISTENT_DATA';
export const ROSI_MAIN_GRID = 'ROSI_MAIN_GRID';
export const PQAS_MAIN_GRID = 'PQAS_MAIN_GRID';
export const QUARTER_DATA_PQAS = 'QUARTER_DATA_PQAS';
export const DETAIL_ROSI_DATA = 'DETAIL_ROSI_DATA';
export const DETAIL_PQAS_DATA = 'DETAIL_PQAS_DATA';
export const TAB_VALUE = 'TAB_VALUE';
